import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import { AnimatePresence, delay, motion, useInView } from 'framer-motion';

import scrollDown from '../assets/img/animations/scrollDownWhite.json'
import circle from '../assets/img/circle.webp'
import { FaInfoCircle } from 'react-icons/fa';
// import { Helmet } from 'react-helmet';

const ScrollInfo = ({
    fadeIn,
    whatWeDoRef
}) => {

    const [scrollInf, setScrollInf] = useState(false)

    const scrollToInfo = () => {
        const offset = 100;
        if (whatWeDoRef.current) {
            const targetPosition = whatWeDoRef.current.getBoundingClientRect().top + window.scrollY - offset;

            // Scroll to the target position with smooth behavior
            window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        } else {
            console.warn("info ref is null. Cannot scroll.");
        }
    };

    const toggleScrollInf = () => {
        if (window.scrollY > 300) {
            setScrollInf(true);
        } else {
            setScrollInf(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });

    };

    useEffect(() => {
        window.addEventListener('scroll', toggleScrollInf);
        return () => {
            window.removeEventListener('scroll', toggleScrollInf);
        };
    }, []);

    const fadeInScroll = {
        initial: {
            opacity: 0,
            y: 60
        },
        animate: {
            opacity: 1,
            y: 0,
            transition: {
                ease: "easeInOut",
                type: "spring",
                duration: 0.35,
                // delay: 2,
                damping: 6,
            }
        },
        exit: {
            opacity: 0,
            y: -60,
            transition: {
                ease: "easeInOut",
                duration: 0.35
            }
        },
    };


    return (
        <div>
            <AnimatePresence mode='wait'>
                {!scrollInf && (
                    <motion.div
                        key={scrollInf}
                        variants={fadeInScroll}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        className="absolute z-[400] xs:bottom-[1rem] xsp:bottom-[2rem] md:bottom-[2.5rem] lg:bottom-[1rem] xl:bottom-[3rem] 2xl:bottom-[3rem] w-full flex flex-col items-center justify-center"
                    >
                        <div className="">
                            <img
                                src={circle}
                                alt="Circle"
                                className='xs:h-[5rem] xs:w-[5rem] xsp:h-[4.75rem] xsp:w-[4.75rem] lg:h-[4rem] lg:w-[4rem] xl:h-[5rem] xl:w-[5rem] 2xl:h-[6.5rem] 2xl:w-[6.5rem] rotateInfinite'
                            />
                        </div>

                        <button
                            onClick={() => {
                                scrollToInfo();
                            }}
                            className={`bg-gradient-to-br from-primaryRichBlue to-primaryRichGreen trns500 xs:p-[0.65rem] xsp:p-[0.5rem] md:p-[0.75rem] lg:p-[0.65rem] xl:p-[0.7rem] 2xl:p-[0.8rem] trns500 group absolute z-[1000] cursor-pointer flex items-center justify-center alata btnTxtSize tracking-[0px] text-white/90 hover:text-black xs:w-[3.5rem] xs:h-[3.5rem] xsp:w-[3.5rem] xsp:h-[3.5rem] lg:w-[3rem] lg:h-[3rem] xl:w-[3.5rem] xl:h-[3.5rem] 2xl:w-[4.5rem] 2xl:h-[4.5rem] rounded-full mx-auto xs:border-[4px] 2xl:border-[5px] border-slate-300/90 hover:border-slate-200 scrollShadowXl xs:outline-[4px] 2xl:outline-[5px] outline-white/60 hover:outline-slate-900/90 ${scrollInf ? 'opacity-0' : 'opacity-100'}`}
                        >
                            {/* <FaArrowDown className='text-[1rem]' /> */}
                            <Lottie
                                animationData={scrollDown}
                                loop={true}
                                style={{ width: '100%', height: '100%' }}
                                className='ml-[0.05rem]'
                            />
                            {/* <div className="absolute w-full h-full bg-gradient-to-br from-black via-black/0 rounded-full opacity-50"></div> */}
                        </button>

                        {/* <p className='absolute -bottom-[4rem] flex items-center justify-center uppercase bg-gradient-to-b from-btnSky to-white h-[3.25rem] xs:px-[3rem] lg:px-[4rem] rounded-full border-[3px] border-white outfit xs:text-[0.5rem] lg:text-[0.55rem] xl:text-[0.6rem] 2xl:text-[0.65rem] tracking-[2px] text-primaryBlue font-[800] xs:mt-[2px] lg:mt-[3px] xl:mt-[5px] shadow-2xl xs:outline-[2px] lg:outline-[4px] 2xl:outline-[6px] outline-white/60'>
                            Scroll Down
                        </p> */}
                        {/* <p className='alata absolute flex flex-row items-center justify-center xs:-bottom-[1.5rem] lg:-bottom-[1.5rem] 2xl:-bottom-[2rem] xs:text-[0.75rem] lg:text-[0.8rem] xl:text-[0.85rem] 2xl:text-[0.9rem] text-slate-500 lowercase tracking-[0.5px]'>
                            <FaInfoCircle className='mr-[0.5rem] -ml-[0.5rem]' />
                            Scroll Down
                        </p> */}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    )
}

export default ScrollInfo